import * as CookieConsent from "vanilla-cookieconsent"
import { updateUtmHistory } from "../../../../../dev/front/js/utmHistory"

const cookiePolicyDocument =
  "https://accolade.eu/files/documents/accolade_cookies_policy_102018_cs.pdf"
export default function intiCookiesConsent() {
  // Ignore cookies if on http
  // if (window.location.protocol === "http:") {
  //   return
  // }

  const lang = document.querySelector("html").getAttribute("lang")

  CookieConsent.run({
    categories: {
      necessary: {
        enabled: true,
        readOnly: true,
      },
      analytics: {},
      marketing: {
        services: {
          utmTracker: {
            label: "UTM Tracking",
            onAccept: () => updateUtmHistory(),
          },
        },
      },
    },
    cookie: {
      sameSite: location.protocol === "https:" ? "None" : "Lax",
    },
    disablePageInteraction: true,
    guiOptions: {
      consentModal: {
        layout: "box inline",
        position: "middle center",
        flipButtons: false,
        equalWeightButtons: false,
      },
      preferencesModal: {
        layout: "box",
        flipButtons: true,
        equalWeightButtons: false,
      },
    },
    language: {
      default: lang,
      translations: translationsObject(),
    },
    onFirstConsent: ({ cookie }) => {
      const analyticsAccepted = CookieConsent.acceptedCategory("analytics")
      const marketingAccepted = CookieConsent.acceptedCategory("marketing")
      checkAnalytics(analyticsAccepted)
      checkMarketing(marketingAccepted)
      dataLayerConsentUpdate()
      consentLog(analyticsAccepted, marketingAccepted)
    },
    onChange: () => {
      checkAnalytics(CookieConsent.acceptedCategory("analytics"))
      checkMarketing(CookieConsent.acceptedCategory("marketing"))
      dataLayerConsentUpdate()
    },
    onModalReady: ({ modalName, modal }) => {
      if (modalName === "consentModal") {
        moveButtons(modal)
      }
    },
  })

  checkAnalytics(CookieConsent.acceptedCategory("analytics"))
  checkMarketing(CookieConsent.acceptedCategory("marketing"))
}

function checkAnalytics(accepted) {
  if (accepted) {
    allowAnalytics()
  } else {
    denyAnalytics()
  }
}

function checkMarketing(accepted) {
  if (accepted) {
    allowMarketing()
  } else {
    denyMarketing()
  }
}

function allowAnalytics() {
  console.log("accepting analytics")
  gtag("consent", "update", {
    analytics_storage: "granted",
  })
}
function denyAnalytics() {
  console.log("denying analytics")
  gtag("consent", "update", {
    analytics_storage: "denied",
  })
}
function allowMarketing() {
  console.log("accepting marketing")
  gtag("consent", "update", {
    ad_storage: "granted",
  })
  console.log("accepting user data")
  gtag("consent", "update", {
    ad_user_data: "granted",
  })
  console.log("accepting personalization")
  gtag("consent", "update", {
    ad_personalization: "granted",
  })
}
function denyMarketing() {
  console.log("denying marketing")
  gtag("consent", "update", {
    ad_storage: "denied",
  })
  console.log("denying user data")
  gtag("consent", "update", {
    ad_user_data: "denied",
  })
  console.log("denying personalization")
  gtag("consent", "update", {
    ad_personalization: "denied",
  })
}

function consentLog(analytics, marketing) {
  const consentLogUrl = document.documentElement.dataset.consentLog
  const url = `${consentLogUrl}&a=${analytics ? "1" : "0"}&m=${
    marketing ? "1" : "0"
  }`
  try {
    const response = fetch(url, {
      method: "GET",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    })
    if (response.status > 300) throw Error()
  } catch (e) {
    console.error(e)
  }
}

function dataLayerConsentUpdate() {
  dataLayer.push({
    event: "consentUpdated",
  })
}

function translationsObject() {
  return {
    en: {
      consentModal: {
        title: "WE VALUE YOUR PRIVACY",
        description: `We’re committed to shaping a better digital experience for you. We use essential cookies to keep our website running smoothly and to provide you with insights that matter. By accepting cookies, you’ll unlock a more personalized experience tailored to your interests.`,
        acceptAllBtn: "ACCEPT ALL",
        acceptNecessaryBtn: "REJECT",
        showPreferencesBtn: "Customize",
      },
      preferencesModal: {
        title: "Cookie preferences",
        acceptAllBtn: "ACCEPT ALL",
        acceptNecessaryBtn: "REJECT",
        savePreferencesBtn: "Save settings",
        closeIconLabel: "Close",
        sections: [
          {
            title: "Use of cookies 📢",
            description: `We use cookies to ensure the basic functions of the website and to improve your online experience. For each category, you can choose whether to log in / out whenever you want, via a link permanently located on the website. Further details regarding cookies can be found in our <a href="${cookiePolicyDocument}" target="_blank">Cookies Policy.</a>.`,
          },
          {
            title: "Essential cookies",
            description:
              "These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly",
            linkedCategory: "necessary",
          },
          {
            title: "Analytics cookies",
            description:
              "These cookies allow the website to remember the choices you have made in the past",
            linkedCategory: "analytics",
          },
          {
            title: "Advertising and marketing cookies",
            description:
              "Marketing cookies are used to track visitors to the website. The intention is to display advertising that is relevant and interesting to the individual user and thus more valuable to publishers and third-party advertisers.",
            linkedCategory: "marketing",
          },
          {
            title: "More information",
            description: `For more information about how we handle personal information, please see our <a class="cc-link" href="${cookiePolicyDocument}" target="_blank">Privacy Policy</a>.`,
          },
        ],
      },
    },
    cs: {
      consentModal: {
        title: "VÁŽÍME SI VAŠEHO SOUKROMÍ",
        description: `Jsme odhodláni vytvářet pro vás lepší digitální zážitek. Používáme nezbytné cookies, aby náš web fungoval bez problémů a poskytoval vám relevantní informace. Přijetím cookies získáte osobnější zážitek přizpůsobený vašim zájmům.`,
        acceptAllBtn: "PŘIJMOUT VŠE",
        acceptNecessaryBtn: "ODMÍTNOUT",
        showPreferencesBtn: "Přizpůsobit",
      },
      preferencesModal: {
        title: "Nastavení cookies",
        acceptAllBtn: "PŘIJMOUT VŠE",
        acceptNecessaryBtn: "ODMÍTNOUT",
        savePreferencesBtn: "Uložit nastavení",
        closeIconLabel: "Zavřít",
        sections: [
          {
            title: "Použití cookies 📢",
            description: `Používáme cookies k zajištění základních funkcí webu a ke zlepšení vašeho online zážitku. Pro každou kategorii můžete kdykoli zvolit, zda se přihlásíte nebo odhlásíte, pomocí odkazu trvale umístěného na webu. Další podrobnosti o cookies naleznete v našem <a href="${cookiePolicyDocument}" target="_blank">Zásady používání cookies.</a>.`,
          },
          {
            title: "Nezbytné cookies",
            description:
              "Tyto cookies jsou nezbytné pro správné fungování mého webu. Bez těchto cookies by web nefungoval správně.",
            linkedCategory: "nezbytné",
          },
          {
            title: "Analytické cookies",
            description:
              "Tyto cookies umožňují webu si pamatovat volby, které jste učinili v minulosti.",
            linkedCategory: "analytické",
          },
          {
            title: "Reklamní a marketingové cookies",
            description:
              "Marketingové cookies se používají ke sledování návštěvníků webu. Účelem je zobrazovat reklamy, které jsou pro konkrétního uživatele relevantní a zajímavé, a tím cennější pro vydavatele a inzerenty třetích stran.",
            linkedCategory: "marketing",
          },
          {
            title: "Více informací",
            description: `Další informace o tom, jak zpracováváme osobní údaje, naleznete v našich <a class="cc-link" href="${cookiePolicyDocument}" target="_blank">Zásady ochrany osobních údajů</a>.`,
          },
        ],
      },
    },
    sk: {
      consentModal: {
        title: "VÁŽIME SI VAŠE SÚKROMIE",
        description: `Sme odhodlaní vytvárať pre vás lepší digitálny zážitok. Používame nevyhnutné cookies, aby naša stránka fungovala hladko a poskytovala vám relevantné informácie. Prijatím cookies získate osobnejší zážitok prispôsobený vašim záujmom.`,
        acceptAllBtn: "PRIJAT VŠETKO",
        acceptNecessaryBtn: "ODMÍTAŤ",
        showPreferencesBtn: "Prispôsobiť",
      },
      preferencesModal: {
        title: "Nastavenia cookies",
        acceptAllBtn: "PRIJAT VŠETKO",
        acceptNecessaryBtn: "ODMÍTAŤ",
        savePreferencesBtn: "Uložiť nastavenia",
        closeIconLabel: "Zavrieť",
        sections: [
          {
            title: "Použitie cookies 📢",
            description: `Používame cookies na zabezpečenie základných funkcií webu a na zlepšenie vášho online zážitku. Pre každú kategóriu si môžete kedykoľvek zvoliť, či sa prihlásite alebo odhlásite, prostredníctvom odkazu trvalo umiestneného na stránke. Ďalšie podrobnosti o cookies nájdete v našom <a href="${cookiePolicyDocument}" target="_blank">Zásady používania cookies.</a>.`,
          },
          {
            title: "Nevyhnutné cookies",
            description:
              "Tieto cookies sú nevyhnutné pre správne fungovanie mojej stránky. Bez týchto cookies by stránka nefungovala správne.",
            linkedCategory: "nevyhnutné",
          },
          {
            title: "Analytické cookies",
            description:
              "Tieto cookies umožňujú stránke zapamätať si voľby, ktoré ste urobili v minulosti.",
            linkedCategory: "analytické",
          },
          {
            title: "Reklamné a marketingové cookies",
            description:
              "Marketingové cookies sa používajú na sledovanie návštevníkov stránky. Účelom je zobrazovať reklamy, ktoré sú pre konkrétneho používateľa relevantné a zaujímavé, a tým cennejšie pre vydavateľov a inzerentov tretích strán.",
            linkedCategory: "marketing",
          },
          {
            title: "Viac informácií",
            description: `Viac informácií o tom, ako spracovávame osobné údaje, nájdete v našich <a class="cc-link" href="${cookiePolicyDocument}" target="_blank">Zásady ochrany osobných údajov</a>.`,
          },
        ],
      },
    },
    de: {
      consentModal: {
        title: "WIR SCHÄTZEN IHRE PRIVATSPHÄRE",
        description: `Wir sind bestrebt, Ihnen ein besseres digitales Erlebnis zu bieten. Wir verwenden notwendige Cookies, damit unsere Website reibungslos funktioniert und Ihnen relevante Informationen liefert. Durch die Annahme von Cookies erhalten Sie ein persönlicheres, auf Ihre Interessen zugeschnittenes Erlebnis.`,
        acceptAllBtn: "ALLE AKZEPTIEREN",
        acceptNecessaryBtn: "ABLEHNEN",
        showPreferencesBtn: "Anpassen",
      },
      preferencesModal: {
        title: "Cookie-Einstellungen",
        acceptAllBtn: "ALLE AKZEPTIEREN",
        acceptNecessaryBtn: "ABLEHNEN",
        savePreferencesBtn: "Einstellungen speichern",
        closeIconLabel: "Schließen",
        sections: [
          {
            title: "Verwendung von Cookies 📢",
            description: `Wir verwenden Cookies, um die grundlegenden Funktionen der Website zu gewährleisten und Ihr Online-Erlebnis zu verbessern. Für jede Kategorie können Sie jederzeit wählen, ob Sie sich an- oder abmelden möchten, über einen dauerhaft auf der Website platzierten Link. Weitere Einzelheiten zu Cookies finden Sie in unserer <a href="${cookiePolicyDocument}" target="_blank">Cookie-Richtlinie.</a>.`,
          },
          {
            title: "Notwendige Cookies",
            description:
              "Diese Cookies sind für das ordnungsgemäße Funktionieren meiner Website unerlässlich. Ohne diese Cookies würde die Website nicht richtig funktionieren.",
            linkedCategory: "necessary",
          },
          {
            title: "Analytische Cookies",
            description:
              "Diese Cookies ermöglichen es der Website, sich an Entscheidungen zu erinnern, die Sie in der Vergangenheit getroffen haben.",
            linkedCategory: "analytics",
          },
          {
            title: "Werbe- und Marketing-Cookies",
            description:
              "Marketing-Cookies werden verwendet, um Besucher auf der Website zu verfolgen. Die Absicht ist, Werbung anzuzeigen, die für den einzelnen Benutzer relevant und interessant ist und somit wertvoller für Publisher und Drittanbieter.",
            linkedCategory: "marketing",
          },
          {
            title: "Weitere Informationen",
            description: `Weitere Informationen darüber, wie wir mit persönlichen Daten umgehen, finden Sie in unserer <a class="cc-link" href="${cookiePolicyDocument}" target="_blank">Datenschutzrichtlinie</a>.`,
          },
        ],
      },
    },
    pl: {
      consentModal: {
        title: "CENIMY TWOJĄ PRYWATNOŚĆ",
        description: `Jesteśmy zaangażowani w tworzenie lepszego cyfrowego doświadczenia dla Ciebie. Używamy niezbędnych plików cookie, aby nasza strona działała płynnie i dostarczała Ci istotnych informacji. Akceptując pliki cookie, uzyskasz bardziej spersonalizowane doświadczenie dostosowane do Twoich zainteresowań.`,
        acceptAllBtn: "ZAAKCEPTUJ WSZYSTKIE",
        acceptNecessaryBtn: "ODRZUĆ",
        showPreferencesBtn: "Dostosuj",
      },
      preferencesModal: {
        title: "Ustawienia plików cookie",
        acceptAllBtn: "ZAAKCEPTUJ WSZYSTKIE",
        acceptNecessaryBtn: "ODRZUĆ",
        savePreferencesBtn: "Zapisz ustawienia",
        closeIconLabel: "Zamknij",
        sections: [
          {
            title: "Użycie plików cookie 📢",
            description: `Używamy plików cookie, aby zapewnić podstawowe funkcje strony i poprawić Twoje doświadczenie online. Dla każdej kategorii możesz wybrać, czy chcesz się zalogować/wylogować w dowolnym momencie, za pomocą linku stale znajdującego się na stronie. Więcej szczegółów dotyczących plików cookie można znaleźć w naszej <a href="${cookiePolicyDocument}" target="_blank">Polityce plików cookie.</a>.`,
          },
          {
            title: "Niezbędne pliki cookie",
            description:
              "Te pliki cookie są niezbędne do prawidłowego funkcjonowania mojej strony internetowej. Bez tych plików cookie strona nie działałaby prawidłowo.",
            linkedCategory: "necessary",
          },
          {
            title: "Pliki cookie analityczne",
            description:
              "Te pliki cookie pozwalają stronie zapamiętać wybory, które dokonałeś w przeszłości.",
            linkedCategory: "analytics",
          },
          {
            title: "Pliki cookie reklamowe i marketingowe",
            description:
              "Pliki cookie marketingowe są używane do śledzenia odwiedzających stronę. Celem jest wyświetlanie reklam, które są istotne i interesujące dla indywidualnego użytkownika, a tym samym bardziej wartościowe dla wydawców i zewnętrznych reklamodawców.",
            linkedCategory: "marketing",
          },
          {
            title: "Więcej informacji",
            description: `Więcej informacji o tym, jak obsługujemy dane osobowe, można znaleźć w naszej <a class="cc-link" href="${cookiePolicyDocument}" target="_blank">Polityce prywatności</a>.`,
          },
        ],
      },
    },
  }
}

function moveButtons(modalEl) {
  const secondGroup = modalEl.querySelector(
    '.cm__btn[data-role="show"]'
  ).parentNode
  const rejectButton = modalEl.querySelector('.cm__btn[data-role="necessary"]')
  secondGroup.insertBefore(rejectButton, secondGroup.firstChild)
}
